// Utility for displaying human-readable names of Market Items categories
export const marketCategoryDisplayNames = {
    'Knowledge': 'Data',
    'Barack Slots': 'Vault Slots',
    'Avatars': 'Agents',
    'Crash Eggs': 'Energy Cells',
};
export function getMarketCategoryDisplayName(category) {
    return marketCategoryDisplayNames[category] || category;
}
